export default "__VITE_ASSET__0cd6b383__"